module.exports = __webpack_public_path__ + "static/2-e3054ba8a80970d720b40b68c4d82948.jpg";